module.exports = __webpack_public_path__ + "img/img_iphone@2x.8d5f1b37.png";